import React, { useEffect, useState } from 'react'
import { IDataDisplayerItem, IDataDisplayerItemField, IDataDisplyerItemActionOption } from './DataDisplayer'
import DataDisplayerItemField, { BaseDataDisplayerItemField } from './DataDisplayerItemField'
import { Checkbox, IconButton } from '@mui/material'
import GenerateIcon from '../GenerateIcon'
import DisplayerItemOptions from './DisplayerItemOptions'
import DataDispplayerSubItems from './DataDispplayerSubItems'

interface IProps extends IDataDisplayerItem {
    selectedList: Array<number>,
    hideColumns: Array<string>,
    updateSelected: (id: number) => void,
    handleDeleteItem: (id: number) => void,
    itemActionOptions: Array<IDataDisplyerItemActionOption>,
    disableSelect?: boolean
}

export default function DataDisplayerItem(props: IProps) {


    const [showSubItems, setShowItems] = useState<boolean>(false)
    const [minContainerWidth, setMinContainerWidth] = useState<number>()

    const { id, fields, selectedList, updateSelected, hideColumns, itemActionOptions, handleDeleteItem, subItems, customHandleDeleteItem, rawItem, disableSelect } = props
    const isSlected = selectedList.includes(id) ? true : false

    const [showOptions, setShowOptions] = useState<boolean>(false)

    const baseContainerClassName: string = "single-data-displayer-item-box"
    const [containerClassName, setContainerClassName] = useState<string>(baseContainerClassName)

    useEffect(() => {
        if (isSlected){
            setContainerClassName(baseContainerClassName + " selected")
        }else{
            setContainerClassName(baseContainerClassName)
        }
    }, [isSlected])

    const containerID: string = "item-wrapper_id_" + id
    const containerElem = document.getElementById(containerID)

    useEffect(() => {
        if (containerElem){
            setMinContainerWidth(containerElem.scrollWidth)
        }
    }, [containerElem])

    return(
        <div className="wrapper-of-single-data-displayer-item-box" id={containerID} style={{ minWidth: minContainerWidth }}>
            <div className={containerClassName}>
                <div className="content-of-single-data-displayer-item-box">

                    {!disableSelect && (
                        <BaseDataDisplayerItemField rawItem={rawItem} type="checkbox-select" maxWidth={65} minWidth={65}>
                            <Checkbox checked={isSlected} onClick={() => updateSelected(id)} />
                        </BaseDataDisplayerItemField>
                    )}

                    {fields.map((field: IDataDisplayerItemField, index: number) => <DataDisplayerItemField rawItem={rawItem} hideColumns={hideColumns} {...field} key={index} />)}

                    <BaseDataDisplayerItemField rawItem={rawItem} type="option-buttons" isActionButtons={true} maxWidth={0} minWidth={0}>

                        {subItems && subItems.length > 0 && (
                            <IconButton onClick={() => setShowItems(showSubItems ? false : true)}>
                                <GenerateIcon icon="arrow-down" />
                            </IconButton>
                        )}

                        <IconButton onClick={() => setShowOptions(true)}>
                            <GenerateIcon icon="options" />
                        </IconButton>

                        <DisplayerItemOptions itemActionOptions={itemActionOptions ? itemActionOptions : []} item={props} isShown={showOptions} handleDeleteItem={customHandleDeleteItem ? customHandleDeleteItem : handleDeleteItem} hideModal={() => setShowOptions(false)} />
                    </BaseDataDisplayerItemField>
                </div>
            </div>

            <DataDispplayerSubItems handleDeleteItem={customHandleDeleteItem ? customHandleDeleteItem : handleDeleteItem} shown={showSubItems} items={subItems ? subItems : []} />
        </div>
    )
}